import React, { useEffect, useRef } from "react";
import {
  Box,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { ReactComponent as TrashIcon } from "../../../assets/icons/trash-icon.svg";
import { announce } from "../../../utils/a11y/announcer";
import visuallyHiddenSx from "../../../utils/a11y/visuallyHiddenSx";

const AssessmentsUploadFileRow = ({ file, onRemove }) => {
  const isDone = file.isSent;
  const wasDoneRef = useRef(isDone);

  useEffect(() => {
    if (isDone && !wasDoneRef.current) {
      announce(`${file.originalName}: arquivo enviado.`);
    }
    wasDoneRef.current = isDone;
  }, [isDone, file.originalName]);

  return (
    <Box
      component="li"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        border: "1px solid #DDDDDD",
        borderRadius: "8px",
        minHeight: "52px",
        maxHeight: "52px",
        p: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: isDone ? "6px" : "8px",
          minWidth: 0,
        }}
      >
        {isDone ? (
          <InsertDriveFileOutlinedIcon
            fontSize="small"
            sx={{ color: "#646568" }}
          />
        ) : (
          <CircularProgress
            size={16}
            thickness={3}
            aria-hidden="true"
            sx={{ color: "#646568" }}
          />
        )}

        <Tooltip title={file.originalName}>
          <Typography
            noWrap
            sx={{ fontSize: "14px", color: "#333333", minWidth: 0, pr: "24px" }}
          >
            {file.originalName}
          </Typography>
        </Tooltip>
        <Box component="span" sx={visuallyHiddenSx}>
          {isDone ? "enviado" : "enviando"}
        </Box>
      </Box>

      <IconButton
        size="small"
        onClick={() => onRemove(file.id)}
        aria-label={
          isDone
            ? `Remover ${file.originalName}`
            : `Cancelar envio de ${file.originalName}`
        }
        sx={{
          width: "36px",
          height: "36px",
          color: isDone ? "#FFFFFF" : "#646568",
          bgcolor: isDone ? "#185CFB" : "transparent",
          borderRadius: "8px",
          "&:hover": {
            bgcolor: isDone ? "#185CFB" : "transparent",
          },
        }}
      >
        <TrashIcon width={20} height={20} aria-hidden="true" focusable="false" />
      </IconButton>
    </Box>
  );
};

export default AssessmentsUploadFileRow;
